import { useEffect } from 'react';
import { css } from '@linaria/core';
import clsx from 'clsx';
import { Icon } from '@cbhq/cds-web/icons';
import { Box, HStack, VStack } from '@cbhq/cds-web/layout';
import { Modal, ModalProps } from '@cbhq/cds-web/overlays';

import { useSimpleBreakpoints } from ':cloud/hooks/useSimpleBreakpoints';

const pointerStyle = { cursor: 'pointer' };

const buildQuestModalStyles = css`
  & .cds-modal {
    & > div {
      background-color: rgba(0, 0, 0, 0.43);
      backdrop-filter: blur(50px);
      border-radius: var(--border-radius-rounded-x-large);
      box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 24px;
    }
  }
  & [data-testid='modal-overlay'] {
    background-color: transparent;
  }
`;

const buildQuestModalStylesDesktop = css`
  & .cds-modal {
    position: absolute;
    top: 0;
    transform: translate(0, 25%) !important;
  }
`;

type BuildQuestModalProps = {
  onRequestClose: () => void;
  width?: number;
  visible: boolean;
  children: React.ReactNode;
} & ModalProps;

export function BuildQuestModal({
  onRequestClose,
  width = 400,
  visible,
  children,
  ...props
}: BuildQuestModalProps) {
  useEffect(() => {
    const modalsContainer = document.getElementById('modalsContainer');
    if (modalsContainer?.children.length === 1) {
      modalsContainer.style.setProperty('--background', 'transparent');
    }
  }, [visible]);

  const { isPhone } = useSimpleBreakpoints();

  return (
    <Modal
      onRequestClose={onRequestClose}
      visible={visible}
      testID="build-quest-modal"
      width={isPhone ? undefined : width}
      dangerouslySetPosition={isPhone ? undefined : 'absolute'}
      className={clsx(buildQuestModalStyles, !isPhone && buildQuestModalStylesDesktop)}
      hideOverlay
      {...props}
    >
      <VStack width="100%" height="100%" spacing={2} spacingBottom={2} alignItems="center">
        <HStack justifyContent="flex-end" alignItems="center" width="100%" spacingBottom={4}>
          <Box onClick={onRequestClose} spacing={1} style={pointerStyle}>
            <Icon name="close" size="s" color="foreground" />
          </Box>
        </HStack>
        {children}
      </VStack>
    </Modal>
  );
}
